// Must run before any library code that expects Node's `global`. Kept out of the
// angular.json `polyfills` option so the builder detects this zoneless app and does NOT
// downlevel async/await — that downleveling injects a `__async` helper that breaks
// mapbox-gl's 3D-model web worker ("__async is not defined"), hiding POIs in 3D mode.
import './polyfills';
import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app-config';

bootstrapApplication(App, appConfig).catch(err => console.error(err));
